import configExample from "./config.example.json";

export interface AppConfigStore {
  SENTRY_DSN: string;
  SENTRY_SAMPLE_RATE: number;
  AKADEMIA_LIBRUS_URL: string;
}

const configIsAppConfig = (
  config: unknown,
  missingKeys: string[],
): config is AppConfigStore => {
  return !!config && missingKeys.length === 0;
};

class AppConfig {
  private _appConfigStore?: AppConfigStore;

  set config(config: any) {
    const example = configExample as Record<string, unknown>;
    const filterUseKeys = Object.keys(example).filter(
      (key) => key.charAt(0) !== "_",
    );
    const missingKeys = [];
    for (const key of filterUseKeys) {
      if (typeof example[key] === typeof config[key]) {
        continue;
      }
      missingKeys.push(key);
    }
    if (configIsAppConfig(config, missingKeys)) {
      this._appConfigStore = config;
      return;
    }
    throw new Error(
      `Bad application configuration! Not set variables: ${missingKeys.join(
        ", ",
      )}`,
    );
  }

  get config(): AppConfigStore {
    if (!this._appConfigStore)
      throw new Error("Application configuration not exists");
    return this._appConfigStore;
  }
}

const appConfigStore = new AppConfig();

export default appConfigStore;
